var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon--svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","role":"img","aria-hidden":"true"}},[_c('path',{attrs:{"d":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }